module.exports = __webpack_public_path__ + "static/front-door-white-sheet-metal-4cc2d6de5fc3ce138458b069ab1fd781.jpg";